import React from 'react';
import Icon from '../../icons/Icon';

function ParticipantPresenceIcon(props) {
    const { className = '', participant } = props;

    if (!participant.is_present) return null;

    return <Icon className={className} src="/img/is_present_icon.png" />;
}

export default ParticipantPresenceIcon;
